class ColorInteraction {
  constructor() {
    this.swatchClicked = this.swatchClicked.bind(this);
    this.swatchHoverIn = this.swatchHoverIn.bind(this);
    this.swatchHoverOut = this.swatchHoverOut.bind(this);
    this.root = '.pc-Style';
    this.swatchContainerSelector = '.pc-SwatchSet-swatches';
    this.swatchSelector = '.pc-Swatch';

    $(document).on(
      'mouseenter.style.colorinteraction',
      `${this.swatchContainerSelector} ${this.swatchSelector}`,
      this.swatchHoverIn
    );
    $(document).on(
      'mouseleave.style.colorinteraction',
      `${this.swatchContainerSelector} ${this.swatchSelector}`,
      this.swatchHoverOut
    );
    $(document).on(
      'click.style.colorinteraction',
      `${this.swatchContainerSelector} ${this.swatchSelector}`,
      this.swatchClicked
    );
    if ($('.pc-Style-hero').length === 0) {
      this.root = '.pc-QuickView-colors';
    }
  }

  swatchClicked(e) {
    e.preventDefault();
    const swatch = this.newSwatch(e);
    $(document).trigger(
      'swatchselect.style.colorinteraction',
      this.swatchData(swatch)
    );
    // Clear selected state from all swatches on the page
    $(`${this.swatchContainerSelector} ${this.swatchSelector}`).removeClass(
      'is-selected'
    );
    // Add selected state to all swatches with this id
    return $(
      `${this.swatchContainerSelector} ${
        this.swatchSelector
      }[data-id='${swatch.data('id')}']`
    ).addClass('is-selected');
  }

  swatchHoverIn(e) {
    const swatch = this.newSwatch(e);
    return $(document).trigger(
      'swatchhover.style.colorinteraction',
      this.swatchData(swatch)
    );
  }

  swatchHoverOut(e) {
    const swatch = this.chosenSwatch();
    return $(document).trigger(
      'swatchhover.style.colorinteraction',
      this.swatchData(swatch)
    );
  }

  // Private: Helpers

  chosenSwatch() {
    return this.swatches().filter('.is-selected');
  }

  newSwatch(e) {
    const s = $(e.target);
    if (s.is('.pc-Swatch')) {
      return s;
    }
    return s.closest('.pc-Swatch');
  }

  swatches() {
    const swatchesSelector = `${this.root} ${this.swatchContainerSelector} ${this.swatchSelector}`;
    return $(swatchesSelector);
  }

  swatchData(swatch) {
    const data = swatch.data();
    data.color = swatch.css('background-color');
    data.trimColor = this.swatchTrim(swatch).css('background-color');
    return data;
  }

  swatchTrim(swatch) {
    return swatch.find('.pc-Swatch-trim');
  }
}

jQuery(() => (ProductCatalog.ColorInteraction = new ColorInteraction()));
